<div class="form-fields-container p-3">
    <!-- Field Name -->
    @if (polyNameControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #nameControl
          [c]="polyNameControl">
        </app-polymorphic-control>
        @if (isDuplicateFieldName) {
          <small class="text-danger d-block mt-1">
            <i class="cil-warning"></i> This field name already exists. Please choose a different name.
          </small>
        }
      </div>
    }

    <!-- Field Type -->
    @if (polyTypeControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #typeControl
          [c]="polyTypeControl">
        </app-polymorphic-control>
      </div>
    }

      <!-- BizEntity Explorer (Only shown when type is bizEntity) -->
    @if (polyBizEntityExplorerControl && showBizEntityExplorer) {
      <div class="mb-3">
        <app-polymorphic-control 
          #bizEntityExplorerControl
          [c]="polyBizEntityExplorerControl">
        </app-polymorphic-control>
      </div>
    }

    <!-- Field Label -->
    @if (polyLabelControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #labelControl
          [c]="polyLabelControl">
        </app-polymorphic-control>
      </div>
    }

        <!-- Min Value -->
    @if (polyMinControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #minControl
          [c]="polyMinControl">
        </app-polymorphic-control>
      </div>
    }

    <!-- Max Value -->
    @if (polyMaxControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #maxControl
          [c]="polyMaxControl">
        </app-polymorphic-control>
      </div>
    }

    <!-- Input Pattern -->
    @if (polyInputPatternControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #inputPatternControl
          [c]="polyInputPatternControl">
        </app-polymorphic-control>
      </div>
    }

    <!-- Validation Messages Section -->
    <!-- <div class="mb-3">
      <label cLabel class="form-label">
        <svg cIcon name="cilWarning" class="me-2"></svg>
        Validation Messages
      </label>
      

      @if (validationMessages.length > 0) {
        <div class="validation-messages-list mb-2">
          @for (msg of validationMessages; track $index) {
            <div class="mb-2 p-2 border rounded">
              @if (isEditingValidationMessage($index)) {
          
                <div class="mb-2">
                  <label cLabel class="form-label small">Validation Key</label>
                  <input 
                    cFormControl
                    type="text" 
                    [(ngModel)]="editingValidationKey"
                    class="form-control form-control-sm">
                </div>
                <div class="mb-2">
                  <label cLabel class="form-label small">Validation Message</label>
                  <input 
                    cFormControl
                    type="text" 
                    [(ngModel)]="editingValidationValue"
                    class="form-control form-control-sm">
                </div>
                <div class="d-flex gap-2">
                  <button 
                    cButton 
                    color="success" 
                    size="sm"
                    (click)="saveEditValidationMessage()"
                    [disabled]="!editingValidationKey.trim() || !editingValidationValue.trim()"
                    type="button">
                    <svg cIcon name="cilCheckAlt" class="me-1"></svg>
                    Save
                  </button>
                  <button 
                    cButton 
                    color="secondary" 
                    variant="ghost"
                    size="sm"
                    (click)="cancelEditValidationMessage()"
                    type="button">
                    <svg cIcon name="cilX" class="me-1"></svg>
                    Cancel
                  </button>
                </div>
              } @else {

                <div class="d-flex align-items-center gap-2">
                  <div class="flex-grow-1">
                    <small class="text-muted d-block">Key:</small>
                    <strong>{{ msg.key }}</strong>
                    <small class="text-muted d-block mt-1">Message:</small>
                    <span>{{ msg.value }}</span>
                  </div>
                  <div class="d-flex gap-1">
                    <button 
                      cButton 
                      color="info" 
                      variant="ghost" 
                      size="sm"
                      (click)="startEditValidationMessage($index)"
                      type="button"
                      title="Edit">
                      <svg cIcon name="cilPencil"></svg>
                    </button>
                    <button 
                      cButton 
                      color="danger" 
                      variant="ghost" 
                      size="sm"
                      (click)="removeValidationMessage($index)"
                      type="button"
                      title="Delete">
                      <svg cIcon name="cilTrash"></svg>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }

  
      <div class="border rounded p-3 bg-light">
        <div class="mb-2">
          <label cLabel for="validationKey" class="form-label small">Validation Key</label>
          <input 
            cFormControl
            id="validationKey"
            type="text" 
            [(ngModel)]="newValidationKey"
            placeholder="e.g., required, minLength, pattern"
            class="form-control form-control-sm">
        </div>
        <div class="mb-2">
          <label cLabel for="validationValue" class="form-label small">Validation Message</label>
          <input 
            cFormControl
            id="validationValue"
            type="text" 
            [(ngModel)]="newValidationValue"
            placeholder="e.g., This field is required"
            class="form-control form-control-sm">
        </div>
        <button 
          cButton 
          color="primary" 
          size="sm"
          (click)="addValidationMessage()"
          [disabled]="!newValidationKey.trim() || !newValidationValue.trim()"
          type="button">
          <svg cIcon name="cilPlus" class="me-1"></svg>
          Add Validation Message
        </button>
      </div>
    </div>
  </div> -->

    <!-- Checkbox Controls -->
    
    <!-- Is Filterable -->
    @if (polyIsFilterableControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #isFilterableControl
          [c]="polyIsFilterableControl">
        </app-polymorphic-control>
      </div>
    }

    <!-- Is Searchable -->
    @if (polyIsSearchableControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #isSearchableControl
          [c]="polyIsSearchableControl">
        </app-polymorphic-control>
      </div>
    }

    <!-- Is Required -->
    @if (polyIsRequiredControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #isRequiredControl
          [c]="polyIsRequiredControl">
        </app-polymorphic-control>
      </div>
    }

    <!-- View In List -->
    @if (polyViewInListControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #viewInListControl
          [c]="polyViewInListControl">
        </app-polymorphic-control>
      </div>
    }

    <!-- Hidden In Form -->
    @if (polyHiddenInFormControl) {
      <div class="mb-3">
        <app-polymorphic-control 
          #hiddenInFormControl
          [c]="polyHiddenInFormControl">
        </app-polymorphic-control>
      </div>
    }

